export default "__VITE_ASSET__DpfNqwFz__"